<template>
    <div class="vx-card px-6 py-2">
        <div class="vx-row">
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select v-model="selectedBranch" :options="branchOptions" name="branch" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">Phân lọai khách hàng</label>
                <v-select v-model="selectedCustomerTypeValue" :options="customerTypeOptions" name="customerType"
                          :clearable="false" :reduce="item => item.value">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-2">
                <label class="vs-input--label">Khách hàng</label>
                <v-select class="w-full" v-model="selectedCustomerValue" :options="paginated"
                          :clearable="false" :filterable="false"
                          @open="onOpen"
                          @close="onClose"
                          @search="searchCustomer" :reduce="item => item.value">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    <template #list-footer>
                        <li ref="load" class="loader">
                            Loading more options...
                        </li>
                    </template>
                </v-select>
            </div>
<!--            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full lg:mt-0 mt-2">-->
<!--                <label class="vs-input&#45;&#45;label">Trạng thái hồ sơ</label>-->
<!--                <v-select v-model="selectedStatusValue" :options="statusOptions" name="status" :clearable="false"-->
<!--                          :reduce="item => item.value">-->
<!--                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>-->
<!--                </v-select>-->
<!--            </div>-->
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full lg:mt-0 mt-2">
                <label class="vs-input--label">Thời gian</label>
                <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="openDateRange"
                                   @update="dateRangePicker" v-model="dateRange" class="w-full">
                </date-range-picker>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 w-1/2 lg:mt-2 sm:mt-2 mt-4">
                <vs-button class="lg:mt-4 sm:mt-6" color="primary" iconPack="feather" icon="icon-search"
                           @click="filter">Tìm
                    kiếm
                </vs-button>
            </div>
        </div>

        <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="receptionData" :animateRows="true" :pagination="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                     :onGridReady="onGridReady" :suppressPaginationPanel="true">
        </ag-grid-vue>

        <div class="vx-row" v-if="receptionData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    receptionData.length - currentPage * pageSize > 0 ? currentPage *
                                        pageSize
                                        : receptionData.length
                                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import Pagination from "../../../ui-elements/Pagination.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
// import CellRendererActions from "./cell-renderer/CellRendererActions";
import CellRendererCustomerStatus from "./cell-renderer/CellRendererCustomerStatus";

export default {
    components: {
        vSelect,
        DateRangePicker,
        AgGridVue,
        Pagination,
        CellRendererStatus,
        // CellRendererActions,
        CellRendererCustomerStatus,
    },

    data() {
        return {
            branchOptions: [],
            selectedBranchValue: null,
            parentId: null,

            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                resizable: true,
            },
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 100,
                    suppressSizeToFit: true
                },
                {
                    headerName: this.$t('menuCustomer.nanoCode'),
                    field: 'nanoCustomerCode',
                    minWidth: 150,
                    suppressSizeToFit: true
                },
                {
                    headerName: this.$t('menuCustomer.customerName'),
                    field: 'customerName',
                    minWidth: 200,
                    suppressSizeToFit: true
                },
                {
                    headerName: this.$t('menuCustomer.birthday'),
                    field: 'birthdayStr',
                    minWidth: 150,
                    suppressSizeToFit: true
                },
                {
                    headerName: this.$t('menuCustomer.gender'),
                    field: 'genderStr',
                    minWidth: 80,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Số điện thoại',
                    field: 'phoneNumberCvt',
                    minWidth: 150,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Phân lọai khách hàng',
                    field: 'customerType',
                    minWidth: 150,
                    cellRendererFramework: 'CellRendererCustomerStatus',
                    suppressSizeToFit: true,
                },
                {
                    headerName: 'Trạng thái hồ sơ',
                    field: 'status',
                    minWidth: 150,
                    cellRendererFramework: 'CellRendererStatus',
                    suppressSizeToFit: true,
                },
                // {
                //     headerName: 'Hành động',
                //     field: 'actions',
                //     minWidth: 100,
                //     cellRendererFramework: 'CellRendererActions',
                //     suppressSizeToFit: true
                // },
            ],
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            dateRange: {
                endDate: new Date(new Date().setHours(23, 59, 59, 999)),
                startDate: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0,0,0,0),
            },
            customerTypeOptions: [
                {value: null, label: "Tất cả"},
                {value: 1, label: "Khách hàng cũ tới tái khám"},
                {value: 2, label: "Khách hàng cũ sử dụng dịch vụ"},
                {value: 3, label: "Khách hàng cũ tới tư vấn dv"},
                {value: 4, label: "Khách hàng mới đến tư vấn"},
                {value: 5, label: "Khách hàng tới mua thuốc mỹ phẩm"},
                {value: 6, label: "Khách hàng trả lại thuốc"},
                {value: 7, label: "Khách hàng tới hoàn phí"},
            ],
            selectedCustomerTypeValue: null,
            receptionData: [],
            customerOptions: [],
            selectedCustomerValue: 'null',
            pageNumberSelectCustomer: 0,
            pageSizeSelectCustomer: 20,
            statusOptions: [],
            selectedStatusValue: 'null',
            openDateRange: 'left',
            observer: null,
            limit: 20,
            search: '',
            typingSearchCustomer: null,
            textTypingSearch: null,
            showListCustomer: false,
        }
    },

    computed: {
        selectedBranch: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.selectedBranchValue)),
                    value: this.branchOptions.find(x => x.value == this.selectedBranchValue)
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
            }
        },

        filtered() {
            return this.customerOptions;
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },
    },

    async created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});

        await this.getParentId();
        this.getReceptionData()
        this.getCustomer();
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
            if (val >= 992) {
                this.openDateRange = 'left'
            } else {
                this.openDateRange = 'right'
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteBeautyBooking'(val) {
            if (val) {
                this.getReceptionData();
                this.$store.commit('DELETE_BEAUTY_BOOKING', false);
            }
        },
        '$store.state.isUpdateFile'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_FILE_SUCCESS', false);
            }
        },
    },

    methods: {
        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getReceptionData();
        },

        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59, 999));
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getReceptionData();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getReceptionData();
        },

        getParentId() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post('/setting-medical-examination-step/find-by-condition', {isGetParent: true}).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.parentId = res.data.content[0].medicalExaminationStep.id;
                    }
                    this.$vs.loading.close();
                    resolve(res)
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getReceptionData() {
            let payload = {
                customerType: this.selectedCustomerTypeValue, //Phân lọai khách hàng
                endDate: this.dateRange.endDate,  //ngày tạo
                loyaltyCustomerId: JSON.parse(this.selectedCustomerValue),
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                startDate: this.dateRange.startDate,
                settingMedicalExaminationStepParentId  : this.parentId, //id trạng thái
            }
            this.receptionData = [];

            this.$vs.loading();
            this.$crm.post('/beauty-medical-record/find-by-condition', payload).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    this.receptionData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.customerName = el.loyaltyCustomer.fullName;
                        el.nanoCustomerCode = el.loyaltyCustomer.nanoCustomerCode;
                        el.phoneNumberCvt = el.loyaltyCustomer.phoneNumber ? this.convertPhone(el.loyaltyCustomer.phoneNumber) : null;
                        el.birthdayStr = el.loyaltyCustomer.birthday ? moment(el.loyaltyCustomer.birthday).format('DD/MM/YYYY') : el.loyaltyCustomer.birthDayRaw;
                        el.genderStr = el.loyaltyCustomer.gender === 0 ? this.$t('genderOption.unknown') : el.loyaltyCustomer.gender === 1 ? this.$t('genderOption.male') : el.loyaltyCustomer.gender === 2 ? this.$t('genderOption.female') : null;
                        return el;
                    })
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        getCustomer() {
            let url = '/loyalty/customer/find'
            if (this.textTypingSearch != this.search) {
                this.textTypingSearch = this.search;
                this.customerOptions = [
                    {value: 'null', label: 'Tất cả'}
                ];
            }
            url += `?pageNumber=${this.pageNumberSelectCustomer}&pageSize=${this.pageSizeSelectCustomer}`;
            if (this.textTypingSearch) url += `&keySearch=${this.textTypingSearch}`;
            this.$vs.loading();
            this.$crm.get(url).then(res => {
                if (res.data.content && res.data.content.length > 0) {
                    let customer = res.data.content.map(el => {
                        return {
                            value: el.id,
                            label: el.phoneNumber + ' - ' + el.fullName
                        }
                    });
                    this.customerOptions.push(...customer);
                }
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        convertPhone(phone) {
            let arrPhone = phone.split('');
            arrPhone[4] = '*';
            arrPhone[5] = '*';
            arrPhone[6] = '*';
            return arrPhone.join().replaceAll(',', '');
        },

        async onOpen() {
            this.showListCustomer = true;
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
        },
        onClose() {
            this.search = '';
            this.pageNumberSelectCustomer = -1;
            this.showListCustomer = false;
            this.observer.disconnect()
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 20;
                this.pageNumberSelectCustomer += 1;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
                this.getCustomer();
            }
        },

        searchCustomer(query) {
            if (this.showListCustomer) {
                if (this.search != query) this.pageNumberSelectCustomer = 0;
                this.search = query;
                clearTimeout(this.typingSearchCustomer);
                this.typingSearchCustomer = setTimeout(this.doneTypingSearch, 1500);
            }
        },

        async doneTypingSearch() {
            await this.getCustomer();
            if (this.customerOptions.length === 1) this.selectedCustomerValue = 'null';
            await this.onOpen();
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
        this.observer = new IntersectionObserver(this.infiniteScroll);
    },
}
</script>

<style>
.vs--single .vs__selected {
    /* max-width: 160px !important; */
    /* min-width: 150px !important; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
